<template>
  <div class="add-hemorrhage public-content">
    <div class="breadcrumb">设置关联</div>
    <div class="third-title" v-if="$route.query.isVip === 'true'"><span>推送产品</span></div>
    <el-form ref="form" v-if="$route.query.isVip === 'true'" :model="form" style="margin:50px 0 0 0" label-width="150px">
      <el-form-item label="推送平台">
        <el-button type="primary" @click="addStoreDialog = true" round>添加平台</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-table border="" :data="tableData" style="width: 500px">
          <el-table-column prop="storeCode" label="平台号"></el-table-column>
          <el-table-column prop="storeName" label="平台名称"></el-table-column>
          <el-table-column prop="storeTypeName" label="平台类型"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="color-blue" @click="deleteStore(scope.row)">移除</span>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div class="third-title"><span>模板</span></div>
    <div class="order-detail-basic">
      <el-table :data="skuGroupList" border style="width: 800px;margin:0 0 0 150px">
        <el-table-column prop="skuGroupName" label="SKU组名称" width="180">
        </el-table-column>
        <el-table-column prop="dictSet" label="属性" width="180">
        </el-table-column>
        <el-table-column prop="skuGroupImage" label="SKU组图片">
          <template slot-scope="scope">
            <img style="max-width:100%" :src="scope.row.skuGroupImage" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="address" label="关联模板">
          <template slot-scope="scope">
            <span class="color-blue" @click="addSkuGroupId = scope.row.id, getSkuListBySkugroupId(scope.row.id), dialogVisible = true">管理模板</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="$router.push('/productlist')">确定</el-button>
    </div>
    <!-- 管理关联模板组 -->
    <el-dialog :close-on-click-modal="false" title="管理SKU" :visible.sync="dialogVisible" width="60%">
      <el-table :data="skuList" border style="width: 100%">
        <el-table-column prop="skuName" label="SKU名称" width="180"> </el-table-column>
        <el-table-column prop="basePage" label="基础P数" width="180"></el-table-column>
        <el-table-column prop="maxPage" label="最大P数"> </el-table-column>
        <el-table-column prop="baseStep" label="一次增加P数"></el-table-column>
        <el-table-column prop="basePagePrice" label="基础P平台价格"></el-table-column>
        <el-table-column prop="baseStepPrice" label="增加一次平台价格"></el-table-column>
        <el-table-column label="尺寸">
          <template slot-scope="scope">
            <span class="color-blue" @click="checkSizeGroup(scope.row)">查看尺寸组</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="模板">
          <template slot-scope="scope">
            <span class="color-blue" @click="addTemplateQueryInfo.pageNum = 1, addType = 'single', addId = scope.row.id, getTemplateGroupList(), dialogVisible2 = true">关联模板</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addTemplateQueryInfo.pageNum = 1, addType = 'all', getTemplateGroupList(), dialogVisible2 = true">统一关联模板</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
      <!-- 关联模板组 -->
      <el-dialog :close-on-click-modal="false" title="模板" :visible.sync="dialogVisible2" @closed="closed" width="70%" append-to-body>
        <el-form :inline="true" :model="searchGroupVo" label-width="100px" ref="aaaform" class="demo-form-inline">
          <el-row>
            <el-row>
              <el-col :span="7">
                <el-form-item label="模板名称:">
                  <el-input v-model="searchGroupVo.groupName" placeholder="请输入模板名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="模板主题:">
                  <el-select v-model="searchGroupVo.templateThemeId" placeholder="请选择">
                    <el-option v-for="item in templateThemeList" :key="item.id" :label="item.themeName" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="模板页性质:">
                  <el-select v-model="searchGroupVo.propertyId" placeholder="请选择">
                    <el-option v-for="item in propertyList" :key="item.id" :label="item.propertyName" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span='10'>
                <el-form-item class="date" label-width="80px" label="创建日期:">
                  <el-date-picker v-model="value1" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <!-- <el-form-item label-width="120px" label="是否关联尺寸组:">
                  <el-select v-model="searchGroupVo.isAssociatedeSizeGroup" placeholder="请选择">
                    <el-option label="不关联" value="0"></el-option>
                    <el-option label="关联" value="1"></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item label-width="120px" label="尺寸组名称:">
                  <el-input v-model="searchGroupVo.composeSizeGroupName" placeholder="尺寸组名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" class="fn-right form-btn">
                <el-button class="search-ok" @click="addTemplateQueryInfo.pageNum = 1, getTemplateGroupList()" round>查询</el-button>
                <el-button class="search-ok" @click="skuAddTemplateGroup()" round type="primary">关联</el-button>
              </el-col>
            </el-row>
          </el-row>
        </el-form>
        <div class="data-list">
          <el-table :data="templateGroupList" @selection-change="selectTemplateGroup" border style="width: 100%">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="id" label="编号"></el-table-column>
            <el-table-column prop="groupName" label="模板名称"></el-table-column>
            <el-table-column prop="propertyName" label="模板页性质"></el-table-column>
            <el-table-column prop="payDate" label="模板页数量">
              <template slot-scope="scope">
                <p v-for="item in scope.row.templateList" :key="scope.row.id + item.typeName">
                  <span @click="getTemplateGroupMsg(scope.row.id), checkTemplateDialog = true" class="color-blue">{{ item.typeName + '模板：' + item.templateNum }}</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="isAssociatedeSizeGroup" label="是否关联尺寸组"></el-table-column>
            <el-table-column prop="themeName" label="主题"></el-table-column>
            <el-table-column prop="createdTime" label="创建日期"></el-table-column>
          </el-table>
          <v-pagination class="v-pagination" :queryInfo="addTemplateQueryInfo" @changePage="tempChangePage"></v-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" width="50%" title="查看模板" :visible.sync="checkTemplateDialog" append-to-body>
          <img style="width:150px;margin:0 5px 5px 0;border:2px solid #000" v-for="item in templateList" :key="item.id + item.sorting" :src="item.templateThumbnail" alt="">
        </el-dialog>
      </el-dialog>
      <!-- 查看尺寸组 -->
      <el-dialog :close-on-click-modal="false" width="900px" title="尺寸组" :visible.sync="innerVisible" append-to-body>
        <el-table :data="checkSizeGroupTableData" border>
          <el-table-column type="expand">
            <template v-slot='scope'>
              <div style="width:100%;height:100%;background:red">
                <el-table :data="scope.row.sizeList" border>
                  <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
                  <el-table-column label="页面类型" prop="typeName">
                    <template slot-scope="scope"> {{ scope.row.pageTypeCode === 'COVER' ? '封面' : scope.row.pageTypeCode === 'TEXT' ? '内页' : scope.row.pageTypeCode === 'SINGLE' ? '单页' : '' }}
                    </template>
                  </el-table-column>
                  <el-table-column label="页面名称" prop="pageName"></el-table-column>
                  <el-table-column label="宽高">
                    <template slot-scope="scope"> 宽度：{{ scope.row.sizeWidth }}mm<br> 高度：{{ scope.row.sizeHeight }}mm </template>
                  </el-table-column>
                  <el-table-column label="出血类型" prop="bleed.bleedName"></el-table-column>
                  <el-table-column label="出血" width="220px">
                    <template slot-scope="scope"> 上方：{{ scope.row.bleed.bleedTop }}mm 下方：{{ scope.row.bleed.bleedBottom }}mm <br> 左侧：{{ scope.row.bleed.bleedLeft }}mm 右侧：{{ scope.row.bleed.bleedRight
                    }}mm <br> 内侧：{{ scope.row.bleed.bleedIn }}mm </template>
                  </el-table-column>
                  <el-table-column label="码" prop="barCodeId">
                    <template slot-scope="scope">
                      <p v-for="item in scope.row.barCodeList" :key="item.id">{{ item.barName }}</p>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="尺寸组名称" min-width="100px" prop="groupName"></el-table-column>
          <el-table-column label="尺寸组类" prop="groupCategoryId" min-width="100px"></el-table-column>
          <el-table-column label="页面名称" prop="pageName" min-width="100px">
            <template slot-scope="scope"> {{ scope.row.pageName.substring(0, scope.row.pageName.length - 1) }} </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="innerVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </el-dialog>
    <!-- 添加平台 -->
    <el-dialog :close-on-click-modal="false" title="添加平台" :visible.sync="addStoreDialog" @closed="closed" width="1100px">
      <el-form :inline="true" :model="storeFormInline" class="demo-form-inline">
        <el-form-item label="平台号：">
          <el-input style="width:150px" v-model="storeFormInline.code" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="业务:">
          <el-input style="width:150px" v-model="storeFormInline.salename" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="手机号:">
          <el-input style="width:140px" v-model="storeFormInline.phone" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="平台类型:">
          <el-select v-model="storeFormInline.storeTypeid" placeholder="请选择">
            <el-option v-for="item in storeTypeList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button @click="getStoreMsg" round>查询</el-button>
      </el-form>
      <el-table ref="multipleTable" :data="storeTableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column label="平台号" prop="code">
        </el-table-column>
        <el-table-column label="平台名称" prop="name">
        </el-table-column>
        <el-table-column label="平台类型" prop="storeType">
        </el-table-column>
        <el-table-column label="业务" prop="salesman.fullName">
        </el-table-column>
        <el-table-column label="手机号" prop="phone">
        </el-table-column>
        <el-table-column label="地址" prop="address.fullAddress">
        </el-table-column>
      </el-table>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addStoreDialog = false">取 消</el-button>
        <el-button type="primary" @click="addStore()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import VPagination from '@/components/Pagination/index.vue'
import { storeSpuList, propertyGetPropertyList, composeGroupDetail, skuAssociateTemplateGroup, groupQueryGroupById, sampleListNoPaging, storeSpuAdd, storeSpuRemove, skuGroupListBySpuId, skuList, groupGetGroupList } from '@/api/pms'
import { storeGetStoreList, storeTypeGetStoreTypeList } from '@/api/crm'
export default {
  name: 'add-hemorrhage',
  components: {
    VPagination
  },
  data () {
    return {
      checkSizeGroupTableData: [],
      innerVisible: false,
      addSkuGroupId: '',
      addId: '',
      addType: '',
      templateList: [],
      checkTemplateDialog: false,
      skuList: [],
      skuGroupList: [],
      templateGroupList: [],
      addTemplateQueryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      queryInfo: {
        pageNum: 1,
        pageSize: 7,
        total: 0
      },
      form: {},
      storeTableData: [],
      value1: [],
      formInline: [],
      storeFormInline: {
        code: '',
        id: '',
        phone: '',
        salename: '',
        salesmanId: '',
        storeTypeid: ''
      },
      code: '',
      categoryList: [],
      addStoreDialog: false,
      dialogVisible: false,
      dialogVisible2: false,
      tableData: [],
      value: true,
      storeTypeList: [],
      multipleSelection: [],
      searchGroupVo: {
        createTimeBegin: '',
        createTimeEnd: '',
        groupName: '',
        isAssociatedeSizeGroup: '',
        composeSizeGroupName: '',
        page: 0,
        propertyId: '',
        templateThemeId: ''
      },
      propertyList: [],
      templateThemeList: [],
      selectTemplateGroupList: []
    }
  },
  watch: {
    value1 (val) {
      if (val) {
        this.searchGroupVo.createTimeBegin = val[0]
        this.searchGroupVo.createTimeEnd = val[1]
      } else {
        this.searchGroupVo.createTimeBegin = ''
        this.searchGroupVo.createTimeEnd = ''
      }
    }
  },
  created () {
    this.getStoreMsg()
    this.getStoreType()
    this.getSkuGroupList()
    this.getTemplateThemeList()
    this.getFormatList()
  },
  methods: {
    // 查看尺寸组
    checkSizeGroup (row) {
      composeGroupDetail(row.composeSizeGroupId).then(res => {
        if (res.data.success) {
          this.checkSizeGroupTableData = [res.data.data]
        }
      })
      this.innerVisible = true
    },
    closed () {
      this.storeFormInline = {
        code: '',
        id: '',
        phone: '',
        salename: '',
        salesmanId: '',
        storeTypeid: ''
      }
      this.searchGroupVo = {
        createTimeBegin: '',
        createTimeEnd: '',
        groupName: '',
        isAssociatedeSizeGroup: '',
        page: 0,
        propertyId: '',
        templateThemeId: ''
      }
      this.value1 = null
    },
    // 关联模板组
    skuAddTemplateGroup () {
      if (this.selectTemplateGroupList.length === 0) {
        this.$message.error('未选择模板组')
        return
      }
      let templateVOList = []
      if (this.addType === 'single') {
        this.selectTemplateGroupList.forEach(tem => {
          templateVOList.push({
            skuId: this.addId,
            templateGroupId: tem.id
          })
        })
      } else if (this.addType === 'all') {
        this.selectTemplateGroupList.forEach(tem => {
          this.skuList.forEach(sku => {
            templateVOList.push({
              skuId: sku.id,
              templateGroupId: tem.id
            })
          })
        })
      }
      skuAssociateTemplateGroup(templateVOList).then(res => {
        if (res.data.success) {
          this.$message.success('关联成功')
          this.dialogVisible2 = false
        }
      })
    },
    // 获取模板组详情
    getTemplateGroupMsg (id) {
      groupQueryGroupById(id).then(res => {
        if (res.data.success) {
          // this.tem
          let arr = []
          res.data.data.templateList.forEach(page => {
            page.templates.forEach(item => {
              arr.push(item)
            })
          })
          this.templateList = arr
        }
      })
    },
    // 获取模板组主题列表
    getTemplateThemeList () {
      sampleListNoPaging().then(res => {
        if (res.data.success) {
          this.templateThemeList = res.data.data
        }
      })
    },
    // 获取模板性质列表
    getFormatList () {
      propertyGetPropertyList().then(res => {
        if (res.data.success) {
          this.propertyList = res.data.data
        }
      })
    },
    // 查询模板组列表
    getTemplateGroupList () {
      groupGetGroupList({ pageNum: this.addTemplateQueryInfo.pageNum, pageSize: this.addTemplateQueryInfo.pageSize, searchGroupVo: this.searchGroupVo }).then(res => {
        if (res.data.success) {
          this.addTemplateQueryInfo.total = res.data.data.total
          this.templateGroupList = res.data.data.records
        }
      })
    },
    // 获取sku组下的sku
    getSkuListBySkugroupId (id) {
      skuList(id).then(res => {
        if (res.data.success) {
          this.skuList = res.data.data.filter(item => {
            return !item.isSample
          })
        }
      })
    },
    // 获取该产品sku组
    getSkuGroupList () {
      skuGroupListBySpuId({ spuId: this.$route.query.id, pageNum: 1, pageSize: 100 }).then(res => {
        if (res.data.success) {
          this.skuGroupList = res.data.data.records
        }
      })
    },
    // 移除平台
    deleteStore (row) {
      storeSpuRemove(row.id).then(res => {
        if (res.data.success) {
          this.$message.success('已删除')
          this.getStoreSpuList()
        }
      })
    },
    // 添加平台
    addStore () {
      if (this.multipleSelection.length === 0) {
        this.$message.success('未勾选平台')
        return
      }
      // let list = new FormData()
      let list = []
      this.multipleSelection.forEach(item => {
        // list.append('storeIdSet', item.id)
        list.push(item.id)
      })
      list = list.join(',')
      storeSpuAdd({ spuId: this.$route.query.id, storeIdSet: list }).then(res => {
        if (res.data.success) {
          this.getStoreSpuList()
          this.addStoreDialog = false
        }
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    selectTemplateGroup (val) {
      this.selectTemplateGroupList = val
    },
    // 获取产品推送平台列表
    getStoreSpuList () {
      storeSpuList({
        spuId: this.$route.query.id,
        pageNum: 1,
        pageSize: 10,
        searchStoreVO: {
          saleMan: '',
          storeCode: '',
          storeName: '',
          storePhone: '',
          storeType: ''
        }
      }).then(res => {
        if (res.data.success) {
          let list = []
          list = res.data.data.records
          this.storeTypeList.forEach(item => {
            list.forEach(val => {
              if (item.code === val.storeType) {
                val.storeTypeName = item.name
              }
            })
          })
          this.tableData = list
        }
      })
    },
    // 获取平台类型
    getStoreType () {
      storeTypeGetStoreTypeList().then(res => {
        if (res.data.success) {
          this.storeTypeList = res.data.data
          this.getStoreSpuList()
        }
      })
    },
    // 获取平台列表
    getStoreMsg () {
      storeGetStoreList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, storeVo: this.storeFormInline }).then(res => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.storeTableData = res.data.data.records
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.getStoreMsg()
    },
    tempChangePage (val) {
      this.addTemplateQueryInfo = val
      this.getTemplateGroupList()
    }
  }
}
</script>
 <style scoped lang="less">
 @deep: ~">>>";
 
 // @{deep} .el-form-item__content{
 //     width: 120px;
 //     height: 30px;
 // }
 .add-hemorrhage {
   .spec-mm {
     span {
       margin-right: 10px;
     }
 
     .el-input {
       width: 110px;
     }
 
     @{deep} .el-input-group__append {
       padding: 0 15px;
     }
   }
 
   .link {
     width: 30px;
     height: 30px;
     border: 1px solid #dcdfe6;
     display: flex;
     align-items: center;
     justify-content: center;
     border-radius: 4px;
     box-sizing: border-box;
 
     i {
       font-size: 20px;
       color: #999;
     }
   }
 
   .active-link {
     background: #1473e6;
     border: 1px solid #1473e6;
 
     i {
       color: #fff;
     }
   }
 }
 </style>
